<template>
    <div>
        <div class="content jidian" style="padding-bottom:10px;">
            <p>西安锦威发挥自身在机电系统节能运行的技术优势，为客户提供覆盖 “节能设计- 施工及调试 – 节能运行-数字化运维”
                的全周期机电系统解决方案，通过各环节的精准把控，实现机电系统建设投资、运行维护费用、系统性能之间的平衡优化。</p>
            <p><img src="../../../../../assets/img/product/jidian/jidian_liucheng.png"></img></p>
        </div>

        <div class="content energy jidian" style="background: #F2F6FA;padding-top:10px;">
            <el-row v-for="(item,index) in contentList" :key="index" :style="{marginTop:item.top}">
                <el-col :span="14" class="left-content" v-if="item.type=='imgLeft'">
                    <div class="img-container" :style="{width:item.imgWidth}"><img
                            :src="require('../../../../../assets/img/product/jidian/jidian_'+item.img+'.png')"></img></div>
                </el-col>
                <el-col :span="10" class="left-content" v-else>
                    <img src="../../../../../assets//img/product/item-icon.png" style="display: inline-block;width: 3em;margin-top: 0;margin-right:1em;"></img>
                    <h3 style="display: inline-block;">{{item.name}}</h3>
                    <ul style="width:38em;">
                        <li v-for="(child,childIndex) in item.childList" :key="childIndex">
                            {{child}}
                        </li>
                    </ul>
                </el-col>

                <el-col :span="10" class="right-content" v-if="item.type=='imgLeft'">
                    <img src="../../../../../assets//img/product/item-icon.png" style="display: inline-block;width: 3em;margin-top: 0;margin-right:1em;"></img>
                    <h3  style="display: inline-block;">{{item.name}}</h3>
                    <ul style="width:35em;">
                        <li v-for="(child,childIndex) in item.childList" :key="childIndex">
                            {{child}}
                        </li>
                    </ul>
                </el-col>
                <el-col :span="14" class="right-content" v-else>
                    <div class="img-container" :style="{width:item.imgWidth}"><img
                            :src="require('../../../../../assets/img/product/jidian/jidian_'+item.img+'.png')"></img></div>
                </el-col>
            </el-row>
        </div>

        <div class="content jidian" style="padding-bottom:10px;">
            <p>在调试与交付阶段，通过 “调试调优 - 性能验证 - 长效保障” 确保节能效果可持续。</p>
            <p>机电系统调试调优并非单次完成，而是分阶段进行：先进行单设备空载调试，确保设备自身节能性能达标；再进行系统联动调试，模拟不同负荷工况下的系统运行状态，反复调整控制参数，直至找到能耗最低、稳定性最优的运行区间；最终通过 72 小时连续满负荷试运行，验证系统综合性能，确保能耗指标、运行稳定性、安全防护均符合预设标准。</p>
            <p>交付环节除移交全套技术文档（含设备说明书、节能运行操作手册等）外，还会为客户运维团队提供专项培训，指导节能操作技巧与日常维护要点；质保期内，西安锦威建立 24 小时响应机制，定期上门巡检系统运行状态，及时排查潜在能耗隐患，确保机电系统在质保期内持续保持高效节能运行状态。</p>
            <p style="text-align: center;"><img src="../../../../../assets/img/product/jidian/jidian_cop.png" style="width:600px;"></img></p>
            <p>从设计到交付的全流程中，西安锦威的解决方案始终以 “客户投资效益最大化” 为核心目标，通过技术深化、精准实施与长效保障，帮助客户实现机电系统能耗降低 20%-30%，同时提升系统运行稳定性与运维效率，为客户创造 “节能 + 降本 + 省心” 的三重价值。</p>
            <p></p>
        </div>
    </div>

</template>

<script>
export default{
    data(){
        return {
            contentList: [{ top: '6em', name: '一体化节能', childList: ['在设计阶段，机电方案以 “一体化节能” 为核心展开三维设计。设备选型环节，并非简单匹配参数，而是结合负荷特性、运行工况波动规律，通过能耗模拟软件测算不同设备的全生命周期能耗，优先选择高效节能型设备（如一级能效电机、变频式空压机等），同时确保设备与现有系统兼容性，避免 “大马拉小车” 的能耗浪费。'], img: 'yitihuajieneng', imgWidth: '90%' },
            { top: '10em', name: '管路低阻力设计', childList: ['管路低阻力设计则依托流体力学仿真技术，优化管路走向与管径配比，选用低摩擦系数的管材，减少管路沿程阻力与局部阻力损失，经测算可降低管路系统能耗占比 15%-20%；'], img: 'guandaozuli', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '控制系统深化设计', childList: ['控制系统深化设计打破传统 “设备 - 管路 - 控制” 分离模式，将设备运行参数、管路流量压力数据与控制系统逻辑深度耦合，引入 PLC 智能控制模块与能耗监测单元，实现设备启停、负荷调节的自动化响应，为后续节能运行奠定基础。'], img: 'kongzhixitong', imgWidth: '90%' },
            { top: '10em', name: '实施落地', childList: ['进入施工阶段，注重 “精度与节能同步落地”。设备及管道安装环节，严格遵循施工规范，保障安全生产、保障安装质量。'], img: 'shishi', type: 'imgLeft', imgWidth: '90%' },
            { top: '10em', name: '控制与节能系统部署', childList: ['控制与节能系统部署则是运行节能的关键，现场调试团队会根据实际运行数据，优化控制算法 —— 例如在动力负荷低谷期，自动切换部分设备为间歇运行模式，或调节管路阀门开度以匹配负荷需求；同时部署远程监控平台，客户可实时查看系统能耗数据、设备运行状态，实现节能运行的可视化管理。'], img: 'keshihua', imgWidth: '85%' }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/product.less';
</style>